/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeDate } from './TimeDate';
import {
    TimeDateFromJSON,
    TimeDateFromJSONTyped,
    TimeDateToJSON,
    TimeDateToJSONTyped,
} from './TimeDate';

/**
 * 
 * @export
 * @interface LastAgreement
 */
export interface LastAgreement {
    /**
     * 
     * @type {string}
     * @memberof LastAgreement
     */
    sourceCaseNoteId: string;
    /**
     * 
     * @type {Date}
     * @memberof LastAgreement
     */
    noteDate: Date | null;
    /**
     * 
     * @type {TimeDate}
     * @memberof LastAgreement
     */
    noteTime: TimeDate | null;
    /**
     * 
     * @type {string}
     * @memberof LastAgreement
     */
    agreement: string | null;
}

/**
 * Check if a given object implements the LastAgreement interface.
 */
export function instanceOfLastAgreement(value: object): value is LastAgreement {
    if (!('sourceCaseNoteId' in value) || value['sourceCaseNoteId'] === undefined) return false;
    if (!('noteDate' in value) || value['noteDate'] === undefined) return false;
    if (!('noteTime' in value) || value['noteTime'] === undefined) return false;
    if (!('agreement' in value) || value['agreement'] === undefined) return false;
    return true;
}

export function LastAgreementFromJSON(json: any): LastAgreement {
    return LastAgreementFromJSONTyped(json, false);
}

export function LastAgreementFromJSONTyped(json: any, ignoreDiscriminator: boolean): LastAgreement {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceCaseNoteId': json['sourceCaseNoteId'],
        'noteDate': (json['noteDate'] == null ? null : new Date(json['noteDate'])),
        'noteTime': TimeDateFromJSON(json['noteTime']),
        'agreement': json['agreement'],
    };
}

export function LastAgreementToJSON(json: any): LastAgreement {
    return LastAgreementToJSONTyped(json, false);
}

export function LastAgreementToJSONTyped(value?: LastAgreement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceCaseNoteId': value['sourceCaseNoteId'],
        'noteDate': value['noteDate'] == null ? value['noteDate'] : `${value['noteDate'].getFullYear()}-${String(value['noteDate'].getMonth()+1).padStart(2,'0')}-${String(value['noteDate'].getDate()).padStart(2,'0')}`,
        'noteTime': TimeDateToJSON(value['noteTime']),
        'agreement': value['agreement'],
    };
}

